import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class MobilizVehicleItem {
  plate: string;
  brandId: number;
  brandName: string;
  createdAt: string; // ISO date
  deviceId: number | null;
  firstDataTime: string; // ISO date
  fleetId: number;
  groupId: number;
  gsmNumber: string;
  hardwareVersion: number;
  lastSyncDate: string; // ISO date
  modelId: number;
  modelName: string;
  muId: number;
  networkId: string;
  protocolVersion: string;
  softwareVersion: number;
  updatedAt: string; // ISO date
  vehicleLabel: string | null;
  vehicleSubTypeId: number | null;
  vehicleTypeId: number;
  id: string;
}

export class MobilizVehicleDetailListResponse extends IPagination {
  @Type(() => MobilizVehicleItem)
  results: MobilizVehicleItem[];
}

export class MobilizQueryVehicleDetailParams extends IQueryPaginationDto {}
